import { defineWidgetCore } from "../../widgetDefinition";
import type { PlayerCardComponentSpec } from "../../Processing/types";
import { buildPlayerCardSnapshot, renderPlayerCard } from "../../PDF/renderers/playerCardPdfRenderer";

export const playerCardCore = defineWidgetCore<PlayerCardComponentSpec>({
  process(spec, response) {
    const ns = response?.non_series_response;
    const data = ns?.type === "player_card" ? ns.data : {};
    return { type: "player_card", spec, data };
  },
  pdf: {
    async prepareSnapshot(snapshot, ctx) {
      // Only the permissioned headshot_image_url is rendered — fetched with auth and
      // inlined as a data-URL (a bare <img>, all react-pdf can do, can't send the auth
      // header → 401). No legacy fallback: un-migrated players (no ref) and fetch
      // failures leave snapshot.headshot unset → the renderer shows the silhouette.
      // The fetch comes from the caller: the browser passes the authed axios call, the
      // headless renderer passes a lookup into its render bundle.
      if (snapshot.type !== "player_card" || !snapshot.headshot_image_url) return;
      snapshot.headshot = await ctx.fetchImageAsDataUri(snapshot.headshot_image_url);
    },
    buildSnapshot({ processed }) {
      return buildPlayerCardSnapshot(processed);
    },
    render({ id, snapshot, rect, scale }) {
      if (snapshot.type !== "player_card") return null;
      return renderPlayerCard(snapshot, rect, scale, id);
    },
  },
});
